module.exports = __webpack_public_path__ + "media/images/qwe-18a66c08.svg";